import { render } from "./KaratayLogo.vue?vue&type=template&id=14286ccf&scoped=true"
import script from "./KaratayLogo.vue?vue&type=script&lang=js"
export * from "./KaratayLogo.vue?vue&type=script&lang=js"

import "./KaratayLogo.vue?vue&type=style&index=0&id=14286ccf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14286ccf"]])

export default __exports__